import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
  inject,
} from "@angular/core";
import { DonutChartConfig } from "./donut-chart.model";
import Chart from "chart.js/auto";
import { TranslocoPipe, TranslocoService } from "@jsverse/transloco";

@Component({
  selector: "er-donut-chart",
  templateUrl: "./donut-chart.component.html",
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
})
export class DonutChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() config!: DonutChartConfig;

  private readonly translocoService = inject(TranslocoService);
  private translatedLabels!: string[];

  public chart!: Chart;

  ngOnInit() {
    this.init();
    this.initTranslateSubscription();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.["config"]?.currentValue) {
      this.init();
    }
  }

  private init() {
    this.initTranslatedLabels();
    this.initChart();
  }

  private initTranslateSubscription() {
    this.translocoService
      .selectTranslate(this.config?.labels[0])
      .subscribe(() => {
        this.init();
      });
  }

  private initTranslatedLabels() {
    this.translatedLabels = [];
    this.config?.labels.forEach((label) => {
      this.translatedLabels.push(this.translocoService.translate(label));
    });
  }

  private initChart() {
    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart("canvas-donut-chart", {
      type: "doughnut",
      data: {
        labels: this.translatedLabels,
        datasets: [
          {
            backgroundColor: this.config?.colors,
            data: this.config?.data,
            hoverBackgroundColor: this.config?.hoverColors?.length
              ? this.config?.hoverColors
              : this.config?.colors,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: (context) => `${context?.raw} %`,
            },
          },
        },
      },
    });
  }

  ngOnDestroy(): void {
    this.chart.destroy();
  }
}
